import React from "react";

const Slide = ({slide, index, activeIndex}) => {
  return (
    <div
      key={index}
      className={index === activeIndex ? "slides active" : "inactive"}
    >
      <img
        src={slide.url}
        alt="carousel image"
        className="carousel-image"
      />
      <h2 className="slide-title">{slide.title}</h2>
      <h3 className="slide-text">{slide.description}</h3>
    </div>
  );
};

export default Slide;
